export default "__VITE_ASSET__DS$5WGiQ__"